import { DateTimePicker } from "@mantine/dates";
import { normalizeDate } from "@/packages/dashboard/utils/date-range-helpers";

type MealTimestampSectionProps = {
  value: Date | null;
  onChange: (value: Date | null) => void;
};

export const MealTimestampSection = ({ value, onChange }: MealTimestampSectionProps) => (
  <DateTimePicker
    label="Meal date & time"
    placeholder="Select when you had this meal"
    popoverProps={{ withinPortal: false }}
    value={value}
    onChange={(next) => {
      const normalized = normalizeDate(next);
      onChange(normalized);
    }}
    valueFormat="MMM DD, YYYY HH:mm"
    required
  />
);
